module.exports = __webpack_public_path__ + "static/overview.da205c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forms/tutorial/overview.png
// module id = 2540
// module chunks = 57689064209437